import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { edit, create } from 'store/document/actions';
import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';

import NPView from '../components/NPView';
import Wrapper from 'routes/Documents/components/Wrapper';

const NPViewContainer = ({ edit, create }) => (
  <Wrapper>
    <DocumentLoader names={['onlineRehabilitation', 'status', 'eq5d', 'msnq', 'fsmc', 'fatigueTrackingDiary']}>
      <DocumentProvider>
        <NPView onStartEdit={edit} onCreate={create} />
      </DocumentProvider>
    </DocumentLoader>
  </Wrapper>
);

NPViewContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit, create })(NPViewContainer);
